







































import { Prop, Component, Vue } from "vue-property-decorator";
import AccountingSearchBar from "@/ui/common/components/AccountingSearchBar.vue";
import VToolbar from "@/components/V-Toolbar.vue";
import { isNewProject } from "@/preferences";
import VIconPrint from "@/components/icons/VIconPrint.vue";
import InfiniteLoading, { StateChanger } from "vue-infinite-loading";

@Component({
  components: {
    AccountingSearchBar,
    VToolbar,
    VIconPrint,
    InfiniteLoading
  }
})
export default class AccountingComponent extends Vue {
  @Prop({ required: true }) mode!: string;
  @Prop({ required: true }) fields!: [];
  @Prop({ required: true }) items!: [];
  @Prop({ default: () => -1 }) isPositionPrinting!: number;

  infiniteLoadingRef: StateChanger | null = null;

  handleSearch() {
    this.$emit("handleSearch", this.infiniteLoadingRef);
  }

  isNewUrl(item: any) {
    if (isNewProject(item.projectCreated)) {
      return `/projects/${item.projectId}/orders/estimates`;
    }

    return `/projects/${item.projectId}/estimates`;
  }

  createPdf(item: any, index: number) {
    this.$emit("handleCreatePdf", item, index);
  }

  loadInfinite($state: StateChanger) {
    this.infiniteLoadingRef = $state;
    this.$emit("loadInfinite", $state);
  }

  get service() {
    return this.$store.state.service;
  }
}
